import {
  ProductRoot
} from "@/components/ProductFullDetail-new/types/product";

export const useGetColorNumber = ({
  product,
  fabricLabel,
  optionSpecs
}: {product: ProductRoot, fabricLabel: string, optionSpecs: string[]}) => {

  const {
    ampProtOption
  } = product || {}
  const {
    items
  } = ampProtOption || {}

  // amp color number
  const colorNumber = items?.find((item) => {
    if (fabricLabel) {
      return item?.label?.includes(fabricLabel?.replace("-default", ""))
    }

    return item?.label?.includes("Color")
  })?.values?.length


  // configurable color number

  const {
    available_product
  } = product || {}
  const {
    configurable_options
  } = available_product || {}

  const colorValues = configurable_options?.find((option: any) => option?.label === "Color")?.values
  const colorValuesLength = colorValues?.length

  // 切换到第二个 tab 时，需要根据 optionSpecs 来计算 colorNumber
  const colorNumberInOptionSpecs = colorValues?.filter((value: any) => optionSpecs.includes(String(value?.value_index)))?.length

  return {
    colorNumber,
    configurableColorNumber: colorNumberInOptionSpecs || colorValuesLength
  }
}
